import { render, staticRenderFns } from "./UpdateInstrument.vue?vue&type=template&id=8214ebc0"
import script from "./UpdateInstrument.vue?vue&type=script&lang=ts"
export * from "./UpdateInstrument.vue?vue&type=script&lang=ts"
import style0 from "./UpdateInstrument.vue?vue&type=style&index=0&id=8214ebc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports